import "@/styles/global.css";
import "@packages/ui/main.css";
import "@webmotors/consumer-shared-ui/styles.css";
import type { AppProps } from "next/app";
import { Figtree } from "next/font/google";
import { AuthProvider, configureAuth } from "@webmotors/consumer-shared-auth";
import DatadogInit from "@/components/datadog/datadog.component";
import { MazeSnippet } from "@/components/maze";
import { QueryProvider } from "@/providers/query-provider";
import { ObservabilityErrorBoundary } from "../services/observability";
import {
  TargetApiProvider,
  TargetApiScript,
} from "@/providers/target-api-provider";

const figtree = Figtree({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800", "900"],
});

type AuthEnv = "production" | "homologation" | "development";

function resolveAuthConfig() {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT;
  if (env === "production") return { env: "production" as AuthEnv };
  if (env === "blue") {
    return {
      env: "production" as AuthEnv,
      loginUrl: "https://azulportal.webmotors.com.br/login/",
      apiUrl: "https://azulportal.webmotors.com.br/api/",
    };
  }
  if (env === "hml") return { env: "homologation" as AuthEnv };
  return {
    env: "development" as AuthEnv,
    loginUrl: "http://localhost:3000/login",
  };
}

configureAuth(resolveAuthConfig());

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${figtree.style.fontFamily};
        }
      `}</style>
      <DatadogInit />
      <MazeSnippet />
      <ObservabilityErrorBoundary>
        <QueryProvider>
          <AuthProvider>
            <TargetApiProvider>
              <TargetApiScript />
              <Component {...pageProps} />
            </TargetApiProvider>
          </AuthProvider>
        </QueryProvider>
      </ObservabilityErrorBoundary>
    </>
  );
}
